import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title: string;
    description: string;
    path: string;
    ogType?: string;
    jsonLd?: object | object[];
}

const SITE_NAME = 'Vibe Commenting';
const BASE_URL = 'https://vibecommenting.com';
const DEFAULT_IMAGE = `${BASE_URL}/logo-white-512.png`;

const SEO: React.FC<SEOProps> = ({ title, description, path, ogType = 'website', jsonLd }) => {
    const canonicalUrl = `${BASE_URL}${path}`;
    const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonicalUrl} />

            {/* Open Graph */}
            <meta property="og:type" content={ogType} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={DEFAULT_IMAGE} />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={DEFAULT_IMAGE} />

            {/* JSON-LD Structured Data */}
            {jsonLdArray.map((schema, index) => (
                <script key={index} type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            ))}
        </Helmet>
    );
};

export default SEO;
